import { useMediaQuery } from 'src/lib/use-media-query'
import { HighlightedText } from 'src/shared/utils/text-highlighter/TextHighlighter'
import styles from 'src/styles/common.module.scss'

const BREAKPOINT_RULES: Record<string, string[]> = {
    desktop: ['OSVOJI'],
    small: ['OSVOJI', 'BREZPLAČNE'],
}

export const TextHeaderSl = () => {
    const isDesktop = useMediaQuery('(min-width: 768px)')

    let breakAfterWords = BREAKPOINT_RULES.small

    if (isDesktop) {
        breakAfterWords = BREAKPOINT_RULES.desktop
    }

    return (
        <HighlightedText
            text="ZAVRTI KOLO IN OSVOJI BREZPLAČNE VRTLJAJE"
            highlights={[{ word: 'BREZPLAČNE' }, { word: 'VRTLJAJE' }]}
            breakAfterWords={breakAfterWords}
            className={styles.text_header}
        />
    )
}
